import { buildIresDeviceFrame } from "./panel/commands/FrameBuilder";

export class IresDeviceFrameBuilder {
  requestId: number;
  currentIndex = 0;

  private payload: number[] = [];

  constructor(requestId: number) {
    this.requestId = requestId;
  }

  addBitField(values: boolean[]) {
    let sum = 0;
    let toAdd = 1;

    values.forEach((value) => {
      if (value) {
        sum += toAdd;
      }

      toAdd *= 2;
    });

    this.addUint8(sum % 256);
  }

  addString(value: string, length: number) {
    const endocdedString = new TextEncoder().encode(value);

    for (let i = 0; i < length; i++) {
      this.payload[this.currentIndex++] = endocdedString[i] ?? 0;
    }

    //Strings a escaped
    this.payload[this.currentIndex++] = 0;
  }

  addBoolean(value: boolean) {
    this.addUint8(value ? 1 : 0);
  }

  addUint8(value: number) {
    this.addInt(value, 1);
  }

  addUint16(value: number) {
    this.addInt(value, 2);
  }

  addUint32(value: number) {
    this.addInt(value, 4);
  }

  private addInt(value: number, numBytes: number) {
    let temp = value;

    const toAdd: number[] = [];

    for (let i = 0; i < numBytes; i++) {
      toAdd.push(temp % 256);
      temp = temp >>> 8;
    }

    toAdd.reverse().forEach((valueToAdd) => this.payload.push(valueToAdd));

    this.currentIndex += numBytes;
  }

  get rawPayload() {
    const data = new Uint8Array(this.payload.length);

    this.payload.forEach((value, index) => (data[index] = value));

    return data;
  }

  toIresDeviceFrame() {
    const data = new Uint8Array(this.payload.length + 1);

    data[0] = this.requestId;

    this.payload.forEach((value, index) => (data[index + 1] = value));

    return buildIresDeviceFrame(data);
  }
}
